export const createCookie = (name: string, value: string, days: number): void => {
    let expires;
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    } else {
        expires = '';
    }

    document.cookie = `${name}=${value} ${expires}; path=/; SameSite=Strict`;
};

export const readCookie = (name: string): string | null => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
};

export const eraseCookie = (name: string): void => {
    createCookie(name, '', -1);
};

export const COOKIE_CONSENT_VERSION = 1;
export const cookieConsentDefaultValue = (acceptAll = false) => ({
    required_storage: true,
    functionality_storage: acceptAll,
    statistics_storage: acceptAll,
    ad_storage: acceptAll,
});

export const hasStatisticsCookie = () => {
    const consentCookie = readCookie(`cookie-consent-${COOKIE_CONSENT_VERSION}`);

    if (consentCookie === null) {
        return false;
    }

    try {
        const consentValues = JSON.parse(consentCookie);

        return consentValues.statistics_storage;
    } catch (_) {
        // Ignore
    }

    return false;
};

/** For regression testing */
export const cookieConsentAll = () => {
    createCookie(
        `cookie-consent-${COOKIE_CONSENT_VERSION}`,
        JSON.stringify(cookieConsentDefaultValue(true)),
        365
    );
};
